import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import(
    /* webpackChunkName: 'Share' */
    '../Share'
  ),
  loading: () => null,
});
